/**
 * Test IDs for QA automation.
 */
export const testIds = {
  supplierContractFormContractNumber: "supplier-contract-form-contract-number",
  supplierContractFormPinCode: "supplier-contract-form-pin-code",
  supplierContractFormRemoveCondition: "supplier-contract-form-remove-condition",
  supplierContractFormSave: "supplier-contract-form-save",
} as const;
